module.exports = __webpack_public_path__ + "static/media/YM40_1.5d390305.jpg";